import React from 'react'
import { constants, formatPrice } from 'common/helpers'

import composeDialogModal from 'components/modals/DialogModal/composeDialogModal'

import messages from './messages'


const AlreadyDowngradeModal = composeDialogModal({
  name: constants.modals.AlreadyDowngrade,
  title: messages.title,
  buttonTitle: messages.buttonTitle,
  contentMessage: ({ data: { price } }) => {
    const isRecurly = typeof price === 'number'

    // Comes from _fetchRecurlyPlansSizes
    if (isRecurly) {
      return {
        ...messages.text.recurly,
        values: {
          price: formatPrice(price, true),
        },
      }
    }

    // Comes from _fetchVindiciaPlansSizes
    return { ...messages.text.vindicia, values: { price } }
  },
})

export default AlreadyDowngradeModal
